import { Badge, Box, Button, Card, CardActions, CardContent, Divider, Grid, Tooltip } from '@material-ui/core'
import React, { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import SendIcon from '@material-ui/icons/Send';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowsDropUpIcon from '@material-ui/icons/ArrowDropUp';
import CachedIcon from '@material-ui/icons/Cached';
import swal from 'sweetalert';
import UserContext from '../../context/Globales/UserContext';
import { DecodificanString } from '../../helpers/Codifican';

import { isMobile } from 'react-device-detect';
const PrincipalSaldo = () => {
    const history = useHistory();
    const { DataTipoContracto, DataSaldo } = useContext(UserContext);
    //const datTipoPlan = JSON.parse(localStorage.getItem('dtc'));
    const dataSaldo = DataSaldo;
    const ClienteId = DecodificanString(JSON.parse(localStorage.getItem('clientId')));
    const ContratoId = DecodificanString(JSON.parse(localStorage.getItem('contractId')));
    const userContext = useContext(UserContext);

    useEffect(() => {
        refreshInformations(ClienteId, ContratoId);
    }, [ClienteId, ContratoId])



    const refreshInformations = () => {

        userContext.getTipoContracto(ClienteId, ContratoId);
    }
    return (
        <>  
        
            <div style={{  alignContent: 'center', width:'100%' }}>
            { isMobile ? <>
              <br /><br /><br />
            <Card>
                <CardContent>
               
              <Grid item xs={12} sm={12} md={12} xl={12} lg={12} >
                <Button variant="outlined" color="primary" onClick={() => history.push('MenuMobile')}>Menú Principal</Button>
              </Grid>
             
                </CardContent>
            </Card>
            </>
              : '' }
        
            {DataTipoContracto && DataTipoContracto.IsPrepago ?
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    >
         

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                        <Card elevation={6}>
                            <CardContent>
                 
                                
                                <br />
                                {dataSaldo ?
                                    <Grid
                                        container
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                        my={2}
                                        spacing={2}
                                    >
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Card>
                            <CardContent>
                                                <p style={{ fontWeight: 'bold', textTransform: 'uppercase'  }}>Historial</p>
                                                <p>Tú plan actual: <br /> <b> <span className="material-icons">
                                    military_tech</span> {DataTipoContracto.Nombre}</b>  <Tooltip title="Refrescar contenido"><Button variant="outlined" color="primary" onClick={refreshInformations}> <CachedIcon /></Button></Tooltip>
                                  </p> 
                                                </CardContent>
                                                </Card>
                                            </Grid>
                                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                            <Card>
                                                <CardContent>
                                                    Saldo Contratado: <br />
                                                    <b style={{ fontSize: '15px' }}>{dataSaldo.Contratado}</b>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                            <Card>
                                                <CardContent>
                                                    Saldo Actual: <br />
                                                    <b style={{ fontSize: '15px' }} >
                                                        {dataSaldo.Saldo > 0 ? dataSaldo.Saldo : <b style={{ fontSize: '15px', color: 'red'}}>{dataSaldo.Saldo} (Estado: Sin Saldo para efectuar consulta)</b> }</b>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                            <Card>
                                                <CardContent>
                                                    Saldo Consumido: <br />
                                                    <b style={{ fontSize: '15px' }}>{dataSaldo.Consumido}</b>
                                                    <ArrowsDropUpIcon />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                      
                                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6} >
                                            <Card style={{ backgroundColor: '#dedfe3' }}>
                                                <CardContent>
                                                    Pts. Principal: <br />
                                                    <b style={{ fontSize: '15px' }}>{dataSaldo.PtsPrincipal}</b>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6} >
                                            <Card style={{ backgroundColor: '#dedfe3' }}>
                                                <CardContent>
                                                    Pts. Detalle: <br />
                                                    <b style={{ fontSize: '15px' }}>{dataSaldo.PtsDetalle}</b>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                    : ''}

                            </CardContent>
                            <Divider />
                            <CardActions>
                                <Button variant="outlined" color="primary" onClick={() => history.push("/soporte")} style={{  alignItems: "center" }}>Contratar mas saldo</Button>
                            </CardActions>
                        </Card>
                    </Grid>




                </Grid>
                :
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    my={2}
                    spacing={2}
                >
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Card elevation={6}>
                            <CardContent>
                                <p> <b> Atención, Imposible mostrar resultado en este momento, intente de nuevo</b></p>
                                <Divider />
                                <br />

                            </CardContent>
                            <CardActions>
                                <Button variant="outlined" color="primary" onClick={() => history.push("/informe")}>Regresar</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>

            }


</div>
        </>
        
    )
}

export default PrincipalSaldo;
